import { Outlet } from "react-router-dom";
import BillingManager from "./BillingManager";
import { useAppSelector } from "../../Redux/hooks";

/**
 * HOC wrapper for all participant detail routes
 * Handles billing timer start/stop when entering/leaving participant detail pages
 */
const ParticipantDetailsWrapper = () => {
  const socketConnected = useAppSelector((state) => state.app.socketConnected);
  // Render child routes
  return (
    <>
      {socketConnected && <BillingManager />}
      <Outlet />
    </>
  );
};

export default ParticipantDetailsWrapper;
